import * as firebase from 'firebase';

firebase.initializeApp({
  apiKey: "AIzaSyC92ik1j81Lbm5VpOFksOQ2GRXfNYHaz6E",
  authDomain: "panagani-app-7878a.firebaseapp.com",
  databaseURL: "https://panagani-app-7878a.firebaseio.com",
  storageBucket: "panagani-app-7878a.appspot.com",
  messagingSenderId: "1017375752408"
});
export const authRef = firebase.auth();



// WEBPACK FOOTER //
// src/reference.js